import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const IntroParagraphCCD: IClientComponentDefinition = {
  name: 'WIntroParagraph',
  load: () => import(/* webpackChunkName: 'WIntroParagraph' */ './intro-paragraph'),
}
